import {
    Box,
    Image,
    Text,
    Badge,
} from "@chakra-ui/react";

import {
    ArrowRight,
} from "lucide-react";

const HelpTopicCard = ({
    topic,
    onClick,
}) => {
    return (
        <Box
            bg="white"
            borderRadius="20px"
            overflow="hidden"
            border="1px solid"
            borderColor="gray.100"
            cursor="pointer"
            transition=".2s"
            onClick={onClick}
            _hover={{
                transform:
                    "translateY(-3px)",
                shadow: "md",
            }}
        >
            <Image
                src={topic.image}
                h="200px"
                w="100%"
                objectFit="cover"
            />

            <Box p={5}>
                <Badge
                    colorPalette="blue"
                    mb={3}
                >
                    {topic.category}
                </Badge>

                <Text
                    fontWeight="700"
                    fontSize="lg"
                    color="#071D54"
                    mb={3}
                >
                    {topic.title}
                </Text>

                <Text
                    color="gray.500"
                    lineClamp="5"
                    minH="120px"
                    mb={4}
                >
                    {topic.description}
                </Text>

                <Text
                    color="#2453FF"
                    fontWeight="600"
                    display="flex"
                    alignItems="center"
                    gap={2}
                >
                    View Topic
                    <ArrowRight
                        size={16}
                    />
                </Text>
            </Box>
        </Box>
    );
};

export default HelpTopicCard;